const Schedule=()=>{
    return(
        <>
        <div>SCHEDULE</div>
        </>
    )
}
export default Schedule;